import { NonAuthSidebar } from '@components/layouts';
import React from 'react';

import { SignupForm } from '@/components/SignupForm';

/**
 * Signup Page
 * Handles user registration for invited users
 */
export function SignupPage() {
  return (
    <div className="flex h-screen overflow-hidden">
      <NonAuthSidebar />
      <div className="flex flex-1 items-center justify-center px-4 sm:px-6 lg:px-8">
        <SignupForm />
      </div>
    </div>
  );
}
